<template>
    <div class="discount">
        <div class="bg"></div>
        <div class="main">
            <!-- 左侧切换区 -->
            <div class="showLeft" v-show="isList">
                <ul>
                    <li :class="currentActTypeId == '' ? 'activety' : ''" @click="changeTab('')">
                        <span class="bgc"></span>
                        <span class="tabText">{{ activityPage.title1 }}</span>
                    </li>
                    <li v-for="item in actTypeList" :key="item.id" :class="currentActTypeId == item.id ? 'activety' : ''"
                        @click="changeTab(item.id)">
                        <span class="bgc"></span>
                        <span class="tabText">{{ item.remark }}</span>
                    </li>
                </ul>
            </div>
            <!-- 右侧内容区 -->
            <el-row class="discountList" v-show="isList">
                <div class="item" v-for="(discount, index) in discountArr" :key="index" v-show="!flag">
                    <!-- <div class="showimg"> -->
                    <img loading="lazy"
                        v-lazy="$common.getImgUrl(discount.picture) ? $common.getImgUrl(discount.picture) : img" />
                    <!-- </div> -->
                    <div class="count">
                        <p class="countp1">{{ discount.name }}</p>
                        <p class="countp2">{{ discount.intro }}</p>
                        <p class="countp3">
                            <img loading="lazy" v-lazy="require('../../assets/images/my/time.png')" />
                            {{ activityPage.activityTime }}：
                            <label v-if="discount.forever == 1">{{ activityPage.title4 }}</label>
                            <label v-if="discount.forever == 0 && discount.type == 0">{{
                                $utils.getTime(discount.validStartTime) + ' 至 '+$utils.getTime(discount.validEndTime)}}</label>
                            <label v-if="discount.forever == 0 && discount.type != 0">{{ $utils.getTime(discount.startTime) + ' 至 '+$utils.getTime(discount.endTime)}}</label>
                            <span @click="getActDetail(discount.id)">{{ activityPage.actDetail }} ></span>
                        </p>
                    </div>
                </div>
                <div v-show="flag">
                    <div class="nodata item">
                        <img loading="lazy" v-lazy="require('../../assets/images/yy/noData.png')" />
                        <p>{{ $t('lotteryGold.nodata') }}</p>
                    </div>
                </div>
            </el-row>
            <!-- 文字提示 -->
            <div v-show="isList && !flag">
                <div v-if="loadingType == 'loading'" class="loadingGif loading-text actTextColor8"
                    style="padding-bottom: 10px;text-align:center">{{ loadingText.loadingRefresh }}</div>
                <div v-else-if="loadingType == 'more'" class="loading-text actTextColor8"
                    style="padding-bottom: 10px;text-align:center">{{ loadingText.loadingDown }}</div>
                <div v-else class="loading-text actTextColor8" style="padding-bottom: 10px;text-align:center">{{
                    loadingText.loadingNoMore }}</div>
            </div>
            <!-- 回到顶部按钮 -->
            <!-- <el-backtop :visibility-height="1" @click="toTop">
                <div
                    class="actToTop"
                    @mouseenter="isToTopHover = true"
                    @mouseleave="isToTopHover = false"
                >
                    <img loading="lazy" v-if="!isToTopHover" v-lazy="require('../../assets/images/yy/act-toTop.png')" alt />
                    <img loading="lazy" v-else v-lazy="require('../../assets/images/yy/act-toTop-hover.png')" alt />
                </div>
            </el-backtop> -->
            <!-- 活动详情 -->
            <div class="discountBox" v-show="!isList">
                <!-- 自助优惠的规则 -->
                <div v-if='$route.query.flag'>
                    <div class="title">
                        <span @click="hideBox" class="closeBTN">{{ activityPage.title5 }}</span>
                        <h2>{{ $route.query.name }}</h2>
                        <p>{{ activityPage.activityTime }}：
                            <label v-if="$route.query.forever == 1">{{ activityPage.title4 }}</label>
                            <label v-else>{{ $utils.getTime(JSON.parse(this.$route.query.startTime)) + ' 至 '+$utils.getTime(JSON.parse(this.$route.query.endTime))}}</label>
                        </p>
                    </div>
                    <div class="count" v-html="intro"></div>
                    <div class="u-flex-all">
                        <div class="button">
                            <div @click="hideBox">{{ activityPage.title5 }}</div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="title">
                        <span @click="hideBox" class="closeBTN">{{ activityPage.title5 }}</span>
                        <h2>{{ activityData.name }}</h2>
                        <p>
                            {{ activityPage.activityTime }}：
                            <label v-if="activityData.forever == 1">{{ activityPage.title4 }}</label>
                            <label v-if="activityData.forever == 0 && activityData.type == 0">{{
                                $utils.getTime(activityData.validStartTime) + ' 至 '+$utils.getTime(activityData.validEndTime)}}</label>
                            <label v-if="activityData.forever == 0 && activityData.type != 0">{{
                                $utils.getTime(activityData.startTime) + ' 至 '+$utils.getTime(activityData.endTime)}}</label>
                        </p>
                    </div>
                    <div class="count" v-html="activityData.rules"></div>
                    <!-- 活动状态 -->
                    <div class="actDetailFooter" id="actDetailFooter">
                        <!-- 跳转活动 -->
                        <template v-if="isShow == 1">
                            <div class="u-flex-all">
                                <div class="button btn">
                                    <div @click="toActivity(jumpType)">参加活动</div>
                                </div>
                            </div>
                        </template>
                        <!-- 站内活动 -->
                        <template v-if="activityData.type != 2">
                            <!-- 活动生效，立即参与 -->
                            <template
                                v-if="!activityData.auditStatus && typeof activityData.auditStatus == 'object' && activityData.isEffect">
                                <div class="u-flex-all">
                                    <div class="button">
                                        <div @click="hideBox">{{ activityPage.title5 }}</div>
                                    </div>
                                    <div class="button btn" @click="partIn()">
                                        <div>{{ activityPage.Immediately }}</div>
                                    </div>
                                    <!-- 立即参与 -->
                                </div>
                            </template>
                            <!-- 进行中 -->
                            <template v-if="typeof activityData.auditStatus == 'number'">
                                <div class="actComplete">
                                    <!-- 活动完成情况 -->
                                    <span class="conTitle">{{ activityPage.status }}:</span>
                                    <span class="themeLightColorClass"
                                        v-if="activityData.auditStatus == 0 && activityData.status == 0">{{
                                            activityPage.ongoing }}</span>
                                    <!-- 进行中 -->
                                    <span class="themeLightColorClass"
                                        v-if="activityData.auditStatus == 0 && activityData.status == 10">{{
                                            activityPage.unfinished }}</span>
                                    <!-- 未完成 -->
                                    <span class="themeLightColorClass"
                                        v-if="activityData.auditStatus == 1 && activityData.status == 0">{{
                                            activityPage.WaitingAudit }}</span>
                                    <!-- 等待审核 -->
                                    <span class="themeLightColorClass"
                                        v-if="activityData.auditStatus == 1 && (activityData.status == 5 || activityData.status == 6)">{{
                                            activityPage.complete }}</span>
                                    <!-- 已完成 -->
                                </div>
                                <div v-if="activityCompletionArr.length > 0">
                                    <div class="actMoney" style="margin-bottom:0.2rem;">
                                        <div style="display:flex;" v-for="(item, i) in activityCompletionArr" :key="i">
                                            <div class="totalDeposit u-flex-all conTitle">{{ item[0] }}：</div>
                                            <div class="themeLightColorClass u-flex-all themeLightColorClass"
                                                style="margin-right:0.40rem;" v-if="item[0] != '局数'">
                                                <div style="margin-right:0.05rem;">¥</div>
                                                <div>{{ $common.setNumFixed(item[1], 2) }}</div>
                                            </div>
                                            <!-- 局数 -->
                                            <div class="themeLightColorClass u-flex-all"
                                                style="margin-right:0.40rem; conTitle" v-else>
                                                <div conTitle>{{ item[1] }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="u-flex-all">
                                    <div class="button">
                                        <div @click="hideBox">{{ activityPage.title5 }}</div>
                                    </div>
                                    <div class="button btn" v-if="actRecordsList && actRecordsList.length > 0"
                                        @click="openActRecords">
                                        <div>{{ activityPage.lookList }}</div>
                                    </div>
                                </div>
                            </template>

                            <!-- 未参与，活动截止 -->
                            <template
                                v-if="!activityData.auditStatus && typeof activityData.auditStatus == 'object' && !activityData.isEffect">
                                <div class="actComplete">
                                    <span class="conTitle">{{ activityPage.status }}:</span>
                                    <span class="themeLightColorClass">{{ activityPage.actend }}</span>
                                    <!-- 活动截止 -->
                                </div>
                                <div v-if="activityCompletionArr.length > 0">
                                    <div class="actMoney" style="margin-bottom:0.2rem;">
                                        <div style="display:flex;" v-for="(item, i) in activityCompletionArr" :key="i">
                                            <div class="totalDeposit u-flex-all conTitle">{{ item[0] }}：</div>
                                            <div class="totalDepositMoney u-flex-all themeLightColorClass"
                                                style="margin-right:0.40rem;">
                                                <div style="margin-right:0.05rem;">¥</div>
                                                <div>{{ $common.setNumFixed(item[1], 2) }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="u-flex-all">
                                    <div class="button">
                                        <div @click="hideBox">{{ activityPage.title5 }}</div>
                                    </div>
                                    <div class="button btn" v-if="actRecordsList && actRecordsList.length > 0"
                                        @click="openActRecords">
                                        <div>{{ activityPage.lookList }}</div>
                                    </div>
                                </div>
                            </template>
                        </template>
                        <!-- 咨询客服领取 -->
                        <template v-if="activityData.type == 2">
                            <div class="u-flex-all">
                                <div class="button">
                                    <div @click="hideBox">{{ activityPage.title5 }}</div>
                                </div>
                                <div class="button btn" @click="toCustomerService">
                                    <div>{{ activityPage.Contactcustomer }}</div>
                                </div>
                                <!-- 联系客服 -->
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <!-- 活动记录 -->
        <el-dialog :title="$t('activityPage.actList')" :visible.sync="dialogVisible" width="666" center>
            <el-table :data="actRecordsList" border
                style="width: 100%;border-color:rgba(87, 96, 126, 0.2);text-align:center">
                <el-table-column prop="censusDate" :label="activityPage.date">
                    <template slot-scope="scope">
                        <div class="u-flex-all">{{ scope.row.censusDate | censusDate }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="activityCompletionStr" :label="activityPage.theConditions">
                    <template slot-scope="scope">
                        <div class="u-flex-all" v-if="scope.row.activityCompletionStr">{{ scope.row.activityCompletionStr }}
                        </div>
                        <div class="u-flex-all" v-else>--/--</div>
                    </template>
                </el-table-column>
                <el-table-column prop="auditStatus" :label="activityPage.completion">
                    <template slot-scope="scope">
                        <div class="u-flex-all" v-if="scope.row.auditStatus == 0 && scope.row.status == 0">
                            {{ activityPage.ongoing }}</div>
                        <!-- 进行中 -->
                        <div class="u-flex-all" v-if="scope.row.auditStatus == 0 && scope.row.status == 10">
                            {{ activityPage.unfinished }}</div>
                        <!-- 未完成 -->
                        <div class="u-flex-all" v-if="scope.row.auditStatus == 1 && scope.row.status == 0">
                            {{ activityPage.WaitingAudit }}</div>
                        <!-- 等待审核 -->
                        <div class="u-flex-all" v-if="scope.row.auditStatus == 1 && scope.row.status == 8">
                            {{ activityPage.notapproved }}</div>
                        <!-- 审核未通过 -->
                        <div class="u-flex-all"
                            v-if="scope.row.auditStatus == 1 && (scope.row.status == 5 || scope.row.status == 6)">
                            {{ activityPage.complete }}</div>
                        <!-- 已完成，奖励已发放 -->
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>
<script>
import { showLogin } from "../login/login.js";
export default {
    data() {
        return {
            discountArr: [],
            dialogVisible: false,
            loadingType: "more", //提示消息，more表示上拉加载更多，loading表示正在加载...，noMore表示没有更多数据了
            loadingText: {
                loadingDown: this.$t("activityPage.Pullmore"), //"下拉加载更多",
                loadingRefresh: this.$t("activityPage.Loading"), // "正在加载..."
                loadingNoMore: this.$t("activityPage.ThereNOdata") //没有更多数据了
            },
            currentPage: 1,
            pageSize: 10,
            totalPages: 1, //list总页数
            isLoading: true,
            isList: true,
            activityData: {},
            // isToTopHover: false,
            forever: 2,
            innerContent: "", //详情内容
            activityCompletionArr: [], //局数列表
            actRecordsList: [], //活动记录列表
            userId: null,
            activityId: null,
            flag: false,
            img: require("../../assets/images/yy/bannerLoading.png"),
            intro: '',
            currentActTypeId: '', //当前活动分类
            actTypeList: [], // 活动分类列表
            scrollTopHeight: 0, //滚动条高度

            isShow: 0, //是否显示活动按钮
            bannerGame: '', //跳转游戏
            jumpType: '', // 跳转类型 4游戏 5大转盘活动类型
            urlId: '', // 跳转活动id
            actFolder: '', // 跳转活动地址
        };
    },
    created() {
        this.getActTypes();
        if (this.$common.getUser()) {
            this.userId = this.$common.getUser().user_id;
        }
        if (this.$route.query.id) {
            this.activityId = this.$route.query.id;
            this.getActDetail(this.$route.query.id);
        }
        //自助优惠跳转进来的逻辑
        if (this.$route.query.flag) {
            this.isList = false;
            this.intro = localStorage.getItem('disIntro')
        }
        if (this.$i18n.locale == "zh_CN") {
            this.img = require("../../assets/images/yy/bannerLoading.png");
        } else {
            this.img = require("../../assets/images/yy/bannerLoading1.png");
        }
    },
    mounted() {
        this.getActivityData();
        window.addEventListener("scroll", this.handleScroll);
    },
    methods: {
        // 获取活动分类
        getActTypes() {
            this.$http.get(this.$api.activityType).then((res) => {
                if (res && res.code == 0) {
                    this.actTypeList = res.data;
                }
            });
        },
        backTop(height) {
            document.body.scrollTop = height;
            document.documentElement.scrollTop = height;
        },
        //点击联系客服
        toCustomerService() {
            if (window.customerServiceStatus == 1) {
                //新客服
                var _this = this;
                var obj = {};
                obj.host = _this.$common.getHost();
                obj.clientCode = window.clientCode;
                obj.clientItem = window.childCode;
                obj.username =
                    this.$common.getUser() && this.$common.getUser().username;
                obj.language = this.$common.getLocale();
                obj.theme = window.theme;
                obj.projectImgUrl = window.projectImgUrl;
                obj.orgin = window.location.origin + "/activity";
                var str = JSON.stringify(obj);
                str = window.btoa(str);
                // var url =
                //     _this.$config.customerServiceUrl +
                //     "/customerService/pc?s=" +
                //     str;
                var url = location.origin + "/func/customerService/pc?s=" + str;
                window.open(url, "_blank");
            } else {
                //旧客服
                const url = this.$common.getCustomerService();
                window.open(url, "_blank");
            }
        },
        //查看活动记录
        openActRecords() {
            this.dialogVisible = true;
        },
        //返回顶部
        // toTop() {
        //     setTimeout(() => {
        //         this.isToTopHover = false;
        //     }, 1000);
        // },
        // //页面滚动
        handleScroll() {
            if (
                window.pageYOffset >
                document.body.offsetHeight - window.innerHeight - 300 &&
                this.isLoading &&
                this.isList
            ) {
                if (this.currentPage < this.totalPages) {
                    this.isLoading = false;
                    this.currentPage++;
                    this.getActivityData();
                }
            }
        },
        //tab切换
        changeTab(id) {
            if (id === this.currentActTypeId) return;
            this.currentActTypeId = id;
            this.flag = false;
            this.loadingType = "more";
            this.currentPage = 1;
            this.discountArr = [];
            this.getActivityData();
        },
        //获取列表
        async getActivityData(currentPage = 1, pageSize = 10) {
            this.loadingType = "loading"; //显示正在加载中。。。。
            var _obj = {
                currentPage: this.currentPage,
                pageSize: this.pageSize,
                ascriptionType: this.currentActTypeId
                // forever: this.forever == 2 ? "" : this.forever
            };
            var res = await this.$http.post(this.$api.activity, _obj, true);
            this.isLoading = true;
            if (res.code == 0) {
                this.totalPages = res.data.totalPages;
                if (res.data.content.length > 0) {
                    this.discountArr.push(...res.data.content);
                } else {
                    //显示数据没有了
                    this.loadingType = "noMore";
                }
                if (this.discountArr.length > 0) {
                    this.flag = false;
                } else {
                    this.flag = true;
                }
                if (this.discountArr.length == res.data.totalRecords) {
                    //显示数据没有了
                    this.loadingType = "noMore";
                } else {
                    //上拉显示更多
                    this.loadingType = "more";
                }
            } else {
                this.$message.error(res.msg);
                this.flag = true;
            }
        },
        //活动详情
        async getActDetail(_id) {
            this.activityId = _id;
            var res = await this.$http.get(this.$api.activityInfo, _id, true);
            if (res.code == 0) {
                this.scrollTopHeight = document.documentElement.scrollTop || document.body.scrollTop;
                this.backTop(0);
                if (res.data.type == 3 && res.data.activityExtensionsVo.url) {
                    //跳转链接
                    window.open(res.data.activityExtensionsVo.url);
                } else if (res.data.activityExtensionsVo && res.data.activityExtensionsVo.type == 4) {  //跳转游戏
                    if (!this.$common.getUser()) {
                        this.$message.warning('请先登录！');
                    } else {
                        this.getToken(res.data.activityExtensionsVo.activityGame, 1)
                    }
                } else {
                    this.isList = false;
                    this.activityData = res.data;
                    this.actRecordsList = res.data.list;
                    this.isShow = res.data.isShow;
                    this.bannerGame = res.data.bannerGame;
                    this.jumpType = res.data.jumpType;
                    this.urlId = res.data.urlId;
                    if (this.jumpType == 5) this.actFolder = res.data.expand.actFolder;
                    if (res.data.list) {
                        //处理记录格式
                        this.actRecordsList.forEach(item => {
                            // 将activityCompletion拼接为字符串
                            let activityCompletion = item.activityCompletion;
                            //
                            if (
                                activityCompletion &&
                                JSON.stringify(activityCompletion) != "{}"
                            ) {
                                let activityCompletionStr = "";
                                for (const k in activityCompletion) {
                                    //取两位小数
                                    let moneyToFixed;
                                    if (k == "局数") {
                                        moneyToFixed = activityCompletion[k];
                                    } else {
                                        moneyToFixed = this.$common.setNumFixed(
                                            activityCompletion[k],
                                            2
                                        );
                                    }

                                    let str = k + moneyToFixed + "，";
                                    activityCompletionStr += str;
                                }
                                activityCompletionStr = activityCompletionStr.substring(
                                    0,
                                    activityCompletionStr.lastIndexOf("，")
                                );
                                this.$set(
                                    item,
                                    "activityCompletionStr",
                                    activityCompletionStr
                                );
                            }
                        });
                    }
                    //type=3时，url为空，content显示responseFields
                    if (
                        res.data.activityExtensionsVo &&
                        !res.data.activityExtensionsVo.url
                    ) {
                        this.innerContent =
                            res.data.activityExtensionsVo.responseFields;
                    } else {
                        this.innerContent = res.data.rules;
                    }
                    if (res.data.intro && this.$route.query.byAppId) {
                        //专题活动内容
                        this.innerContent = res.data.intro;
                    }
                    // if (this.innerContent) {
                    //     this.innerContent = this.innerContent.replace(
                    //         /\<img/gi,
                    //         '<img style="max-width:100%;height:auto"'
                    //     );
                    // }
                    let activityCompletion = res.data.activityCompletion;
                    this.activityCompletionArr = [];
                    if (
                        activityCompletion &&
                        JSON.stringify(activityCompletion) != "{}"
                    ) {
                        for (const k in activityCompletion) {
                            this.activityCompletionArr.push({
                                0: k,
                                1: activityCompletion[k]
                            });
                        }
                    }
                    this.activityData.rules = this.innerContent
                }
            } else {
                this.$message.error(res.msg);
            }
        },
        // 进入活动
        toActivity(type) {
            switch (type) {
                case 4:
                    if (this.$common.getUser()) {
                        this.getToken(this.bannerGame, 1);
                    } else {
                        this.$message.warning('请先登录')
                    }
                    break;
                case 5:
                    if (this.$common.getUser()) {
                        // 双旦活动
                        this.jump11();
                    } else {
                        this.$message.warning('请先登录')
                    }
                    break;
                case 1:
                    window.open(this.activityData.url);
                    break;
                case 7: //站内页
                    if (this.activityData.needLogin == 1 && !this.$common.getUser()) {
                        this.$message.warning('请先登录')
                        return
                    }
                    this.$router.push({ path: this.activityData.url })
                    break;
            }
        },
        // 进入游戏
        getToken: async function (req, index) {
            let self = this;
            var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);

            if (!self.$common.getUser()) {
                self.$message.warning('请登录')
                return
            }
            self.tenantId = self.$common.getUser().tenant_id
            self.username = self.$common.getUser().username
            self.uid = self.$common.getUser().user_id
            let datas = {
                tenantId: self.tenantId,
                username: self.username,
                gameId: index == 2 ? req.ids : req.id,
                clientIp: self.$config.clientIp,
                memberId: self.uid,
                terminalType: 1
            }
            self.$common.setGameRequestData(datas)

            const res = await self.$http.post(this.$api.getToken, datas, true)
            if (res.code == 0) {
                self.gameUrl = res.data;
                if (req.openMode === 1) {
                    // if(issafariBrowser) {
                    //  self.winOpen.location.href = self.gameUrl;
                    // }else{
                    window.open(self.gameUrl)
                    // }

                } else {
                    window.open(self.gameUrl)
                }

            } else {
                if (req.openMode === 1) {
                    window.open('/error.html?type=1')
                    // self.winOpen.location.href = '/error.html?type=1';
                }

                if (req.status === 0) {
                    self.$message.error('维护中')
                } else {
                    self.$message.error('进入游戏失败，请稍后重试！')
                }
            }
        },
        // 双十一/大转盘活动类型
        jump11() {
            if (!this.$common.getUser()) {
                this.$message.warning('请先登录！');
                return;
            }
            const obj = {
                activityId: this.urlId,
                token: this.$common.getToken(),
                clientCode: window.clientCode,
                username: this.$common.getUser().username,
                language: "zh_CN",
                theme: window.theme,
                host: this.$config.baseUrl,
            };
            const str = window.btoa(JSON.stringify(obj));
            const url = window.location.origin + '/func/' + this.actFolder + "/pc/index.html?s=" + str;
            window.open(url);
        },
        hideBox() {
            this.isList = true;
            setTimeout(() => {
                this.backTop(this.scrollTopHeight);
            }, 100);
        },
        //点击立即参与
        partIn: async function () {
            var _this = this;
            if (!this.$common.getUser()) {
                //没有登录
                _this.$message.warning('请先登录！');
            } else {
                //已登录
                var params = {
                    memberId: this.userId,
                    activityId: this.activityId
                };
                const res = await this.$http.putUrl(
                    _this.$api.joinAct,
                    params,
                    true
                );
                if (res.code == 0) {
                    this.getActDetail(this.activityId);
                    this.$message.success(this.$t("activityPage.Participate"));
                }
            }
        }
    },
    computed: {
        activityPage() {
            return this.$t("activityPage");
        }
    },
    filters: {
        //过滤日期
        censusDate(val) {
            if (val) {
                var date = new Date(val); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var M = date.getMonth() + 1;
                var D = date.getDate();
                return M + "月" + D + "日";
            } else {
                return "--/--";
            }
        }
    },
    watch: {
        $route: {
            handler(val, oldVal) {
                if (this.$route.query.id) {
                    this.getActDetail(this.$route.query.id);
                }
            },
            deep: true
        },
        "$i18n.locale"(val) {
            if (this.$i18n.locale == "zh_CN") {
                this.img = require("../../assets/images/yy/bannerLoading.png");
            } else {
                this.img = require("../../assets/images/yy/bannerLoading1.png");
            }
        }
    }
};
</script>
<style  lang="scss" >
.discount {
    .el-dialog__header {
        padding: 20px 20px 10px;
        font-weight: bold;
    }

    .el-table td,
    .el-table th.is-leaf {
        text-align: center;
    }
}
</style>
<style lang="scss" scoped>
.discount {
    position: relative;
    background-color: #fafafa;
    min-height: 512px;

    // .showimg{
    //   display: inline;
    // }
    .closeBTN:hover {
        color: blue;
    }

    .bg {
        width: 100%;
        min-width: 1200px;
        height: 512px;
        position: absolute;
        top: 0px;
        left: 0;
        background: #210339 url("../../assets/images/my/discount1.jpg") no-repeat center -8px !important;
        // z-index: -1;
    }

    .u-flex-all {
        align-items: flex-start;
    }

    .actDetailFooter {
        margin: 10px 0;
    }

    .actComplete {
        margin: 10px 0;

        .conTitle {
            color: #f01924;
        }
    }

    .actMoney {
        >div {
            margin: 10px 0;
        }
    }

    //回到顶部
    .el-backtop {
        right: calc((100% - 13.41rem) / 2 - 1.5rem) !important;
        background-color: transparent;
        width: auto;
        height: auto;
        border-radius: 0;
    }

    .actToTop {
        width: 45px;
        height: 45px;
        z-index: 99;

        img {
            width: 100%;
        }
    }

    .main {
        position: relative;
        width: 1200px;
        margin: 0 auto;
        padding-top: 120px;

        .showLeft {
            width: 170px;
            background-color: #f5f5f5;
            position: absolute;
            z-index: 10;

            ul {
                overflow: hidden;
                text-align: center;

                li {
                    float: left;
                    width: 100%;
                    height: 70px;
                    line-height: 70px;
                    background: #fff;
                    font-size: 14px;
                    border-bottom: 1px solid #eaeaea;
                    font-weight: 600;
                    color: #404040;
                    cursor: pointer;
                    display: flex;
                    align-items: center;

                    .bgc {
                        position: relative;
                        display: inline-block;
                        width: 20px;
                        height: 20px;
                        margin: 0 15px 0 30px;
                        background: url("../../assets/images/yy/icon2.png") 0 0 no-repeat;
                    }

                    .tabText {
                        max-width: 105px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }

                .activety {
                    color: #f01924;

                    .bgc {
                        position: relative;
                        background: url("../../assets/images/yy/icon1.png") 0 0 no-repeat;
                    }
                }
            }
        }

        .discountList {
            padding-left: 170px;
            min-height: 550px;

            .item {
                float: left;
                width: 1000px;
                background: #fff;
                border-right: 1px solid #eee;
                box-shadow: 0 6px 12px rgba(0, 0, 0, 0.05);
                margin: 0 0 20px;
                height: 180px;

                >img {
                    width: 450px;
                    float: left;
                    height: 180px;
                }

                .count {
                    width: 550px;
                    float: left;

                    .countp1 {
                        font-size: 16px;
                        font-weight: 600;
                        line-height: 40px;
                        color: #111;
                        padding: 15px 25px 0;
                        border-top: 1px solid #eee;
                    }

                    .countp2 {
                        line-height: 20px;
                        font-size: 12px;
                        color: #999;
                        height: 67px;
                        padding: 5px 25px 0;
                    }

                    .countp3 {
                        height: 52px;
                        line-height: 52px;
                        color: #aaa;
                        border-top: 1px solid #eee;
                        font-size: 12px;

                        img {
                            width: 17px;
                            margin-left: 30px;
                            margin-right: 5px;
                        }

                        span {
                            width: 150px;
                            text-align: center;
                            border-left: 1px solid #eee;
                            color: #f01924;
                            font-size: 14px;
                            float: right;
                            cursor: pointer;
                            margin-right: -2px;
                        }
                    }
                }

                &:hover {
                    box-shadow: 0 5px 30px rgba(0, 0, 0, 0.15);
                    border-color: #e6e6e6;

                    .count {
                        .countp3 {
                            span {
                                background: #f01924;
                                border-color: #f01924;
                                color: #fff;
                            }
                        }
                    }
                }
            }
        }

        .discountBox {
            background: #fff;
            padding: 0 40px;

            .title {
                padding-top: 20px;
                padding-bottom: 35px;
                border-bottom: 2px solid #dcdcdc;
                text-align: center;
                position: relative;

                span {
                    position: absolute;
                    top: 40px;
                    left: 40px;
                    font-size: 16px;
                    cursor: pointer;
                }

                h2 {
                    font-size: 28px;
                    font-weight: 200;
                    line-height: 60px;
                }

                p {
                    padding: 0 6px;
                    font-size: 14px;
                    color: #aaa;
                }
            }

            .count {
                padding: 30px 0;
                min-height: 300px;
            }

            .button {
                text-align: center;
                padding-top: 10px;
                padding-bottom: 30px;
                margin-right: 10px;

                div {
                    display: inline-block;
                    cursor: pointer;
                    min-width: 100px;
                    height: 40px;
                    line-height: 40px;
                    border-radius: 20px;
                    background: #000;
                    font-size: 18px;
                    color: #fff;

                    &:hover {
                        opacity: 0.8;
                    }
                }
            }

            .btn {
                div {
                    padding: 0 15px;
                    background-color: #f01924;
                }
            }
        }
    }

    .nodata {
        height: 210px !important;
        text-align: center;
        padding-top: 20px;

        img {
            float: none !important;
            display: block;
            width: 264px !important;
            height: 178px !important;
            position: relative;
            left: 50%;
            transform: translateX(-50%);
        }
    }
}</style>